export default function() {
  return {
    email: null,
    name: null,
    short_name: null,
    password: null,
    roles: {
      id: null,
      name: null
    },
    active: 0,
  }
}